module.exports = __webpack_public_path__ + "static/media/Yellow-browed Bulbul.c73c4622.png";